import {trackEvent} from './utilities/index';

let Controls = function () {
  if (Controls.prototype._singletonInstance) {
    return Controls.prototype._singletonInstance;
  }
  Controls.prototype._singletonInstance = this;

  this.initialize();
}

Controls.prototype.initialize = function () {

  let self = this;

  let controlsEl = document.getElementById('controls');
  let backBtn = document.getElementById('previous');
  let nextBtn = document.getElementById('next');

  let controlsActive = false;
  let nextBtnActive = false;
  let backBtnActive = false;

  let nextTrackingObj = {
    action: null,
    label: null,
    value: null
  };

  self.el = controlsEl;
  self.backBtn = backBtn;
  self.nextBtn = nextBtn;

  this.enable = function () {
    controlsEl.classList.remove('is-disabled');
    controlsActive = true;
  }

  this.disable = function () {
    nextBtn.blur();
    backBtn.blur();
    controlsEl.classList.add('is-disabled');
    controlsActive = false;
  }

  this.enableNextButton = function () {
    nextBtn.classList.remove('disabled');
    nextBtnActive = true;
  }

  this.setNextTrackingObj = function (trackingObj) {
    nextTrackingObj = trackingObj;
  }

  this.disableNextButton = function () {
    nextBtn.classList.add('disabled');
    nextBtnActive = false;
  }

  this.enableBackButton = function () {
    backBtn.classList.remove('disabled');
    backBtnActive = true;
  }

  this.disableBackButton = function () {
    backBtn.classList.add('disabled');
    backBtnActive = false;
  }

  nextBtn.addEventListener('click', function () {
    if (!controlsActive || !nextBtnActive) {
      return;
    }
    if (self.onNextButtonClick) {
      // trackEvent('navigation', 'Next');
      trackEvent('answer', nextTrackingObj.label, nextTrackingObj.value, nextTrackingObj.action);
      self.onNextButtonClick();
    }
  });

  backBtn.addEventListener('click', function () {
    if (!controlsActive || !backBtnActive) {
      return;
    }
    if (self.onBackButtonClick) {
      trackEvent('navigation', 'Previous');
      self.onBackButtonClick();
    }
  });

}

export default Controls;
